import { useState } from "react";
import { ChevronDown, Cloud, Sparkle, Star, Sun } from "lucide-react";
import PandaBook from "../../assets/images/Panda/red-panda-computer.png";
import ResponsiveImage from "../common/ResponsiveImage";
import { FAQSectionProps } from "../../models";

export default function SectionQuestion({ faqs, title, img }: FAQSectionProps) {
  const [activeKey, setActiveKey] = useState<string | null>(null);

  const toggle = (key: string) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div className="mt-10 overflow-hidden bg-[var(--bgBlue)]">
      <section className="container relative w-full">
        <div className="mb-5 flex items-center justify-center pt-[30px] mobile598:mb-10">
          <h2 className="text-xl font-bold text-[var(--textBlue57)] mobile598:text-3xl md:text-4xl">
            {title}
          </h2>
        </div>
        <div className="absolute -left-32 bottom-0 h-72 w-72 rounded-full bg-red-200/20 blur-3xl" />
        <div className="absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-rose-300/20 blur-3xl" />
        <div className="color-main absolute -right-0 top-40 z-20 rotate-45 text-6xl font-extrabold tracking-widest opacity-20">
          FAQ
        </div>
        <Sun
          size={60}
          fill="currentColor"
          className="absolute top-30 left-2 animate-spin-slow text-[var(--textBlue57)] opacity-50"
        />
        <Cloud
          size={50}
          className="absolute top-25 right-[20px] animate-float text-[var(--textBlue57)] opacity-40"
        />
        <Star
          size={30}
          fill="currentColor"
          className="absolute bottom-10 left-10 animate-pulse text-[var(--textBlue57)] opacity-30"
        />
        <Sparkle
          size={30}
          className="absolute top-25 left-[calc(50%+180px)] animate-bounce text-[var(--textBlue57)]"
        />

        <div className="flex w-full flex-col gap-6 px-4 pb-10 pt-[10px] mobile598:px-6 mobile598:pt-[30px] mdconfig:flex-row mdconfig:gap-x-4 mdconfig:px-10">
          <div className="hidden mdconfig:block mdconfig:w-2/5">
            <div className="relative min-h-[360px] lg:min-h-[390px]">
              {img ? (
                img
              ) : (
                <ResponsiveImage
                  className="absolute -top-2 left-0 w-[86px] object-cover sm:w-[104px] mdconfig:-top-4 mdconfig:w-[250px] lg:-top-5 lg:w-[300px]"
                  src={PandaBook}
                  alt="Panda Mascot"
                />
              )}
            </div>
          </div>

          <div className="w-full rounded-xl bg-white p-5 box-shadow-second mdconfig:w-3/5">
            {faqs.map((item) => (
              <div key={item.key} className="border-b last:border-none">
                <button
                  onClick={() => toggle(item.key)}
                  className="flex w-full items-center justify-between py-3 text-left text-[12px] font-medium text-gray-800 mobile598:text-[14px] lg:py-4 lg:text-[16px]"
                >
                  {item.q}
                  <ChevronDown
                    size={20}
                    strokeWidth={3}
                    className={`text-red-500 transition-transform duration-300 ${
                      activeKey === item.key ? "rotate-180" : "rotate-0"
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    activeKey === item.key ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="pb-4 text-left text-[12px] leading-6 text-gray-600 mobile598:text-[14px] lg:text-[16px]">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
